import { ErrorOrError } from '../models/error-or-error.model';
import { ApiProblemDetails, ModelStateDictionary } from '../interfaces/problem-details.interface';
import { ErrorType } from '../enums/error-type.enum';
import { HttpStatusCode } from '../../../../../trash/shared/enums/http-status-code.enum';

export class ErrorOrHttpExtensions {
    public static toErrorOrErrors(problemDetails: ApiProblemDetails): ErrorOrError[] {
        const errors: ErrorOrError[] = [];

        if (!problemDetails.errors) {
            const error = this.toErrorOrError(problemDetails.status, problemDetails.title);
            errors.push(error);
            return errors;
        }

        errors.push(...this.toErrorOrErrorsFromModelState(problemDetails.errors, problemDetails.status));
        return errors;
    }

    public static toErrorOrError(statusCode: HttpStatusCode, errorMessage?: string): ErrorOrError {
        switch (statusCode) {
            case HttpStatusCode.CONFLICT:
            case HttpStatusCode.BAD_REQUEST:
                return errorMessage ? ErrorOrError.validation(errorMessage) : ErrorOrError.validation();
            case HttpStatusCode.NOT_FOUND:
                return errorMessage ? ErrorOrError.notFound(errorMessage) : ErrorOrError.notFound();
            case HttpStatusCode.UNAUTHORIZED:
                return errorMessage ? ErrorOrError.unAuthorized(errorMessage) : ErrorOrError.unAuthorized();
            case HttpStatusCode.FORBIDDEN:
                return errorMessage ? ErrorOrError.forbidden(errorMessage) : ErrorOrError.forbidden();
            default:
                return errorMessage ? ErrorOrError.failure(errorMessage) : ErrorOrError.failure();
        }
    }

    public static toErrorOrErrorsFromModelState(modelStateDictionary: ModelStateDictionary, statusCode?: number): ErrorOrError[] {
        const errors: ErrorOrError[] = [];

        for (const key in modelStateDictionary) {
            const entry = modelStateDictionary[key];
            if (!entry) {
                continue;
            }

            entry.forEach(errorMessage => {
                const errorCode = statusCode
                    ? this.getErrorFromModelStateEntry(statusCode, key, errorMessage)
                    : ErrorOrError.failure(key, errorMessage);
                errors.push(errorCode);
            });
        }

        return errors;
    }

    private static getErrorFromModelStateEntry(statusCode: number, key: string, errorMessage: string): ErrorOrError {
        switch (statusCode) {
            case HttpStatusCode.CONFLICT:
            case HttpStatusCode.BAD_REQUEST:
                return ErrorOrError.validation(key, errorMessage);
            case HttpStatusCode.NOT_FOUND:
                return ErrorOrError.notFound(key, errorMessage);
            case HttpStatusCode.UNAUTHORIZED:
                return ErrorOrError.unAuthorized(key, errorMessage);
            case HttpStatusCode.FORBIDDEN:
                return ErrorOrError.forbidden(key, errorMessage);
            default:
                return ErrorOrError.failure(key, errorMessage);
        }
    }

    public static isValidationErrors(errors: ErrorOrError[]): boolean {
        return errors.every(err => err.type === ErrorType.VALIDATION);
    }
}
